/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import commonCompat from '../common/compat';
import UserGamificationInfos from './components/UserGamificationInfos';
import ExpPoints from './expPoints/components/ExpPoints';
import LeaderboardHero from './leaderboards/components/LeaderboardHero';
import LeaderboardItemList from './leaderboards/components/LeaderboardItemList';
import LeaderboardListItem from './leaderboards/components/LeaderboardListItem';
import LeaderboardPage from './leaderboards/components/LeaderboardPage';
import LeaderboardPodium from './leaderboards/components/LeaderboardPodium';
import LeaderboardSidebar from './leaderboards/components/LeaderboardSidebar';
import LeaderboardToolbar from './leaderboards/components/LeaderboardToolbar';
import PodiumListItem from './leaderboards/components/PodiumListItem';
import SelfRankCard from './leaderboards/components/SelfRankCard';
import LeaderboardState from './leaderboards/states/LeaderboardState';
import LevelHistory from './levels/models/LevelHistory';

export default {
	...commonCompat,
	'gamilytics/forum/components/UserGamificationInfos': UserGamificationInfos,
	'gamilytics/forum/expPoints/components/ExpPoints': ExpPoints,
	'gamilytics/forum/leaderboards/components/LeaderboardHero': LeaderboardHero,
	'gamilytics/forum/leaderboards/components/LeaderboardItemList': LeaderboardItemList,
	'gamilytics/forum/leaderboards/components/LeaderboardListItem': LeaderboardListItem,
	'gamilytics/forum/leaderboards/components/LeaderboardPage': LeaderboardPage,
	'gamilytics/forum/leaderboards/components/LeaderboardPodium': LeaderboardPodium,
	'gamilytics/forum/leaderboards/components/LeaderboardSidebar': LeaderboardSidebar,
	'gamilytics/forum/leaderboards/components/LeaderboardToolbar': LeaderboardToolbar,
	'gamilytics/forum/leaderboards/components/PodiumListItem': PodiumListItem,
	'gamilytics/forum/leaderboards/components/SelfRankCard': SelfRankCard,
	'gamilytics/forum/leaderboards/states/LeaderboardState': LeaderboardState,
	'gamilytics/forum/levels/models/LevelHistory': LevelHistory,
};
